import HeadComponent from 'next/head';

const title = '세일즈클루: PDF·링크 공유와 고객 행동 분석 플랫폼';

const description =
  'PDF와 링크를 공유하고, 리드 수집부터 열람·클릭·다운로드 데이터까지 한곳에서 확인하세요. 1:1 추적과 대량발송으로 관심 고객을 빠르게 발견할 수 있습니다.';

const keywords =
  '세일즈클루, SalesClue, PDF 공유, 링크 공유, 리드 수집, 고객 행동 분석, B2B 세일즈, B2B 마케팅, 고객관리, CRM, 세일즈 자동화, 영업관리, 열람 추적, 클릭 추적, 다운로드 추적';

const ogImage =
  'https://cdn.salesclue.io/production/common/resources/ogi-260613.png';

const url = 'https://app.salesclue.io';

const Head = () => {
  return (
    <HeadComponent>
      <title key="title">{title}</title>

      <meta
        key="viewport"
        name="viewport"
        content="width=device-width, initial-scale=1.0"
      />

      <meta key="keywords" name="keywords" content={keywords} />
      <meta key="metaTitle" name="title" content={title} />
      <meta key="description" name="description" content={description} />
      <meta
        key="author"
        name="author"
        content="Narrative Inc., 주식회사 내러티브"
      />
      <meta key="robots" name="robots" content="all" />

      <meta key="ogType" property="og:type" content="website" />
      <meta key="ogSiteName" property="og:site_name" content="SalesClue" />
      <meta key="ogTitle" property="og:title" content={title} />
      <meta
        key="ogDescription"
        property="og:description"
        content={description}
      />
      <meta key="ogImage" property="og:image" content={ogImage} />
      <meta key="ogUrl" property="og:url" content={url} />
      <meta key="ogLocale" property="og:locale" content="ko_KR" />

      <meta
        key="twitterCard"
        name="twitter:card"
        content="summary_large_image"
      />
      <meta key="twitterTitle" name="twitter:title" content={title} />
      <meta
        key="twitterDescription"
        name="twitter:description"
        content={description}
      />
      <meta key="twitterImage" name="twitter:image" content={ogImage} />
    </HeadComponent>
  );
};

export default Head;
